import React, { useState } from 'react';
import { Candy, PartyPopper, Mail, Heart, GlassWater, Apple, Check, Plus, Gift, ArrowUpRight } from 'lucide-react';
import { GIFT_ADDONS, SHOP_URL } from '../mock';
import Reveal from './Reveal';

const ICONS = { Candy, PartyPopper, Mail, Heart, GlassWater, Apple };

export default function GiftAddons() {
  const [selected, setSelected] = useState([]);

  const toggle = (id) => {
    setSelected((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));
  };

  const total = GIFT_ADDONS.filter((a) => selected.includes(a.id)).reduce((sum, a) => sum + a.price, 0);

  return (
    <section className="py-20 lg:py-24 bg-[#F1ECE3]">
      <div className="max-w-6xl mx-auto px-5 lg:px-8">
        <Reveal>
          <div className="text-center max-w-2xl mx-auto mb-12">
            <span className="inline-flex items-center gap-2 text-[13px] tracking-[0.3em] uppercase text-[#C4715A] font-medium">
              <Gift className="w-4 h-4" /> Make it extra special
            </span>
            <h2 className="font-serif-display text-[34px] sm:text-[44px] text-[#26302a] mt-3 leading-tight">Add a little something more</h2>
            <p className="mt-4 text-[16px] text-[#5A554C]">Complete your gift with a thoughtful add-on. Select your favourites and add them to your order at checkout.</p>
          </div>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {GIFT_ADDONS.map((a, i) => {
            const Icon = ICONS[a.icon] || Gift;
            const active = selected.includes(a.id);
            return (
              <Reveal key={a.id} delay={(i % 3) * 80}>
                <button
                  onClick={() => toggle(a.id)}
                  className={`w-full text-left flex items-center gap-4 rounded-2xl border p-5 transition-all duration-300 ${
                    active
                      ? 'bg-[#EAF1E7] border-[#3D5142] shadow-[0_10px_30px_rgba(61,81,66,0.12)]'
                      : 'bg-white border-[#EFE8DD] hover:border-[#C9BBA9] hover:-translate-y-0.5'
                  }`}
                >
                  <span className={`shrink-0 w-14 h-14 rounded-xl flex items-center justify-center transition-colors ${active ? 'bg-[#3D5142]' : 'bg-[#EDE7DC]'}`}>
                    <Icon className={`w-6 h-6 ${active ? 'text-[#E9D4CE]' : 'text-[#3D5142]'}`} />
                  </span>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between gap-2">
                      <h3 className="font-serif-display text-[18px] text-[#2A2A28] leading-tight">{a.name}</h3>
                      <span className="font-medium text-[15px] text-[#3D5142] whitespace-nowrap">+${a.price}</span>
                    </div>
                    <p className="text-[13px] text-[#6A655C] mt-0.5">{a.desc}</p>
                  </div>
                  <span className={`shrink-0 w-7 h-7 rounded-full flex items-center justify-center border transition-all ${active ? 'bg-[#3D5142] border-[#3D5142]' : 'border-[#D3C7B6]'}`}>
                    {active ? <Check className="w-4 h-4 text-white" /> : <Plus className="w-4 h-4 text-[#B0A692]" />}
                  </span>
                </button>
              </Reveal>
            );
          })}
        </div>

        {/* Summary bar */}
        <Reveal delay={120}>
          <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-4 bg-white rounded-2xl border border-[#EFE8DD] px-6 py-5">
            <p className="text-[15px] text-[#5A554C]">
              {selected.length === 0 ? (
                'No add-ons selected yet — tap any card above.'
              ) : (
                <>
                  <span className="font-medium text-[#2A2A28]">{selected.length} add-on{selected.length > 1 ? 's' : ''} selected</span>
                  <span className="text-[#8A7C6A]"> · </span>
                  <span className="font-medium text-[#3D5142]">+${total}</span>
                </>
              )}
            </p>
            <a
              href={SHOP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full bg-[#C4715A] hover:bg-[#a95a45] text-white text-[15px] font-medium px-6 py-3 transition-colors"
            >
              Add to your order <ArrowUpRight className="w-4.5 h-4.5" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
